module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_5-688b679cfae82592206cf91f1bf4669d.jpg";